import { trackEvent } from '@/api'
import { useMutation } from '@/utils'

export const useTrackEvent = () => useMutation(trackEvent)
